@if (componentData$ | async; as data) {
  <div class="w-100 custom-align-center">
    <a routerLink="{{data.url}}" class="nav-link secondary-anchor custom-align-center">
      {{data.linkName ? data.linkName : data.name}}
    </a>
  </div>
}